import { createFormHook } from '@tanstack/react-form';

import {
  TextInputField,
  DateInputField,
  SelectInputField,
  CheckboxField,
  TextareaInputField,
} from './components/fields';
import {
  FormGrid,
  SaveFormActions,
  Form,
  FormFieldset,
} from './components/form';
import { fieldContext, formContext } from './formContext';

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInputField,
    DateInputField,
    SelectInputField,
    CheckboxField,
    TextareaInputField,
  },
  formComponents: {
    Form,
    FormGrid,
    SaveFormActions,
    FormFieldset,
  },
});
